import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className="About">
      <h2>AS COACHING</h2>
      <div className="about-container">
        <div className="text">
          <p>
            Introducing AS Coaching, a cutting-edge coaching service by
            certified coach and transformation specialist Anthony Savvides,
            designed to help you transform your body and achieve your fitness
            goals. With AS Coaching, you'll receive personalized training plans,
            expert guidance and support to maximize your results.
            <br />
            Whether you're looking to build muscle, lose weight, or improve your
            overall fitness, our tailored approach and proven strategies will
            help you reach new heights.
            <br /> <br />
            Join AS Coaching and experience the transformation you've always
            desired.
          </p>
          <a href="#plans">
            <button>Get started!</button>
          </a>
        </div>
        <div className="img">
          <img src="/images/aboutAS.jpeg" alt="about" />
        </div>
      </div>
    </div>
  );
}
